import React from 'react';
import { TouchableOpacityProps } from 'react-native';
import styled from 'styled-components/native';

const StyledButton = styled.TouchableOpacity<IconButtonProps>`
  width: ${p => (p.size === 'small' ? 24 : 32)}px;
  height: ${p => (p.size === 'small' ? 24 : 32)}px;
  border-radius: ${p => (p.size === 'small' ? 12 : 16)}px;
  align-items: center;
  justify-content: center;
` as React.FC<IconButtonProps>;

export type IconButtonProps = TouchableOpacityProps & {
  size?: 'normal' | 'small';
};

const IconButton: React.FC<IconButtonProps> = ({
  size,
  children,
  ...props
}) => {
  return (
    <StyledButton activeOpacity={0.7} size={size} {...props}>
      {children}
    </StyledButton>
  );
};

export default IconButton;
